import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';
import cx from 'classnames';

import ManageRatings from '../../../components/SiteAdmin/ManageRatings';
import Loader from '../../../components/Common/Loader/Loader';

import getReviews from './getReviews.graphql'
import messages from '../../../locale/messages';

import s from './Ratings.css';

export class Ratings extends Component {

    static defaultProps = {
        booking: {
            loading: true
        }
    }

    render() {
        const { reviews, reviews: { loading, getReviews } } = this.props;
        const { formatMessage } = this.props.intl;

        return (
            <Loader type={"page"} show={loading}>
                <div className={s.root}>
                    {!loading && <div className={s.container}>
                        <div className={cx(s.heading, 'textAlignRightRTL', 'textWhite')}>
                            {formatMessage(messages.ratings)}
                        </div>
                        <div className={s.paddingRoutesSection}>
                            <ManageRatings reviews={reviews} />
                        </div>
                    </div>}
                </div>
            </Loader>
        );
    }
}

export default compose(
    injectIntl,
    withStyles(s),
    graphql(getReviews, {
        name: 'reviews',
        options: {
            variables: {
                currentPage: 1,
                searchList: ''
            },
            fetchPolicy: 'network-only'
        }
    })
)(Ratings);
